import API from "./api";

// GET
export const getDailyServices = (includeInactive = false) => {
    return API.get(`/DailyService?includeInactive=${includeInactive}`);
};

// ADD
export const addDailyService = (data) => {
    return API.post("/DailyService", data);
};

// UPDATE
export const updateDailyService = (id, data) => {
    return API.put(`/DailyService/${id}`, data);
};

// DELETE
export const deleteDailyService = (id) => {
    return API.delete(`/DailyService/permanent/${id}`);
};